import React, { useEffect, useState } from 'react';
import './TraitRevealCard.scss';
import cls from 'classnames';
import { Logo } from './Logo';
import { BaseTraitCard, TraitPreview, TraitType } from './BaseTraitCard';

const SHINE_TIMEOUT = 1500;

export type TraitRevealCard = {
  name: string;
  description: string;
  type: TraitType;
  flipped: boolean;
  onFlip: () => void;
  src?: string;
};

export const TraitRevealCard = ({ type, src, flipped, onFlip, ...rest }: TraitRevealCard) => {
  const [shine, setShine] = useState(false);

  function classes() {
    return cls('trait-card', 'flip', flipped ? 'flip-animation' : 'scale-animation');
  }

  useEffect(() => {
    if (flipped) {
      const timeout = setTimeout(() => setShine(true), SHINE_TIMEOUT);
      return () => clearTimeout(timeout);
    }
  }, [flipped]);

  return (
    <div className={classes()} onClick={onFlip} role="button">
      <div className="trait-card front">
        <Logo />
      </div>

      <BaseTraitCard
        className={cls('trait-card', 'back', shine && 'card-shine')}
        preview={<TraitPreview className="traitPreview" src={src} type={type} />}
        {...rest}
      />
    </div>
  );
};
